// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"2e55223d","152":"f4e71d6f","365":"5286e74e","370":"25e3ffbc","390":"aeeb6e51","406":"a18413e3","787":"6520ff22"}[chunkId] + ".chunk.js";
};